import { Controller } from "@hotwired/stimulus"

// Reports an impression for a Workplace content card once at least half of it
// has stayed in the viewport for a moment (TMS-1241's rule): counting on render
// would inflate every denominator with cards nobody scrolled to. Fires at most
// once per card per page; the server keeps it to one per member, item and day.
export default class extends Controller {
  static values = {
    url: String,
    contentType: String,
    contentId: String,
    dwell: { type: Number, default: 1000 }
  }

  connect() {
    if (!this.urlValue || !this.contentTypeValue || !this.contentIdValue) return
    if (!("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver(entries => this.track(entries), { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.cancelDwell()
    this.observer?.disconnect()
  }

  track(entries) {
    const visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5)
    visible ? this.startDwell() : this.cancelDwell()
  }

  startDwell() {
    if (this.timer || this.sent) return

    this.timer = setTimeout(() => this.report(), this.dwellValue)
  }

  cancelDwell() {
    clearTimeout(this.timer)
    this.timer = null
  }

  report() {
    this.timer = null
    if (this.sent || document.visibilityState === "hidden") return

    this.sent = true
    this.observer?.disconnect()
    fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this.csrfToken, "Accept": "application/json" },
      body: JSON.stringify({ content_type: this.contentTypeValue, content_id: this.contentIdValue })
    }).catch(() => {})
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
